// extracted by mini-css-extract-plugin
module.exports = {"recordingIndicator":"recordingIndicator_recordingIndicator__3BDEX","progressDot":"recordingIndicator_progressDot__YzFLU","dotInner":"recordingIndicator_dotInner__2EWZ6"};